function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { getIconButtonSize } from 'theming/tokens/components/button';
import { ReactComponent as ThreeDots } from 'assets/animations/three_dots.svg';
import * as S from './IconButton.styles';
const IconButtonComponents = {
  primary: S.IconButtonFilled,
  outline: S.IconButtonOutline,
  text: S.IconButtonText
};
const IconButton = /*#__PURE__*/React.forwardRef(({
  icon,
  variant,
  type = 'button',
  ariaLabel,
  ...props
}, ref) => {
  if (variant === 'text') {
    props.hasPadding = props.hasPadding ?? false;
  }
  const iconDimension = getIconButtonSize(props.size);
  const loadingIndicator = /*#__PURE__*/React.createElement(ThreeDots, {
    width: iconDimension,
    height: iconDimension
  });
  const IconButtonComponent = IconButtonComponents[variant ?? 'primary'];
  const {
    loading,
    outlineFocusColor,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(S.IconButtonWrapper, {
    $disabled: props.disabled || loading
  }, /*#__PURE__*/React.createElement(IconButtonComponent, _extends({
    ref: ref,
    disabled: props.disabled || loading,
    type: type,
    "aria-label": loading ? 'Loading' : ariaLabel,
    $size: props.size,
    $hasPadding: props.hasPadding,
    $outlineFocusColor: outlineFocusColor
  }, rest), props.loading ? loadingIndicator : icon));
});
export { IconButton };